import moment from "moment";
import { attendanceCodeError } from "services";
import { designations } from "./userProfile"
import { useState } from "react";
import { isValidPhoneNumber } from "react-phone-number-input";

export const validateEmail = (emailId) => {
    if (!emailId || emailId === "") {
        return false
    }
    const email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailId?.match(email)) {
        return false
    } else {
        return true
    }
}

export const isPhoneFormatInvalid = (phone) => {
    if (!phone) return false;
    const clean = String(phone).replace(/[^0-9]/g, '');
    if (clean.startsWith('91')) {
        if (clean.length > 2) {
            const firstDigit = clean.charAt(2);
            if (firstDigit < '6' || firstDigit > '9') return true;
        }
    }
    return false;
}

export const superAdminProfileDetails = (userProfileDetails, handleInputChange, user, validateData, handleAddrDuplicate, userRowDetails, onCheckChange, privilages, phoneExistsError) => {
    const isStudent = userProfileDetails?.role?.includes('Student');
    function disabledDate(current) {
        // For students, disable future dates
        if (isStudent) {
            // return current && current >= moment().subtract(3, "years");
            return current && current > moment().endOf("day");
        }

        // For others, allow only dates before 14 years from today
        return current && current >= moment().subtract(14, "years");
    }



    let sameAsCa = false;
    const [dummySameAsCa, setDummySameAsCa] = useState(false)
    const permanentAddress = userProfileDetails?.basicprofile?.permanentAddress || userProfileDetails?.user?.basicprofile?.permanentAddress;

    if (typeof permanentAddress === "string" && permanentAddress.trim() !== "") {
        try {
            const parsedAddress = JSON.parse(permanentAddress);
            sameAsCa = parsedAddress?.sameAsCa ?? false;
        } catch (error) {
            console.error("Error parsing permanentAddress:", error);
            sameAsCa = false;
        }
    } else if (typeof permanentAddress === "object") {
        sameAsCa = permanentAddress?.sameAsCa ?? false;
    }


    return [
        {
            heading: "Basic information",
            fields: [
                {
                    label: "Name", type: "text", value:
                        userProfileDetails?.name, required: true, disabled: false,
                    onChange: e => handleInputChange(e.target.value, "name"),
                    placeholder: "Enter name..."
                },
                {
                    label: isStudent ? "Student Code" : "Employee Code", type: "text", value:
                        userProfileDetails?.attendanceEmpCode || "", required: !!userProfileDetails?.registerBiometric, disabled: false,
                    onChange: e => handleInputChange(e.target.value, "attendanceEmpCode"),
                    placeholder: isStudent ? "Enter Student Code..." : "Enter Employee Code...",
                    error: attendanceCodeError(userProfileDetails?.attendanceEmpCode),
                    key: `emp-code-${userProfileDetails?.attendanceEmpCode || "empty"}`, // Add a key that changes when the value changes
                    checkboxAbove: {
                        label: "Register on biometric device",
                        checked: !!userProfileDetails?.registerBiometric,
                        onChange: e => handleInputChange(e.target.checked, "registerBiometric"),
                    }
                },
                isStudent ? null : userRowDetails?.role == 'Student' || userRowDetails?.role == 'Data Operator' || userRowDetails?.role == 'Teacher' || userRowDetails?.role == 'Operation' ? null :
                    {
                        label: "Designation", type: "select",
                        value: userProfileDetails?.designation, required: true, disabled: false,
                        onChange: e => handleInputChange(e, "designation"),
                        options: designations,
                        placeholder: "Select Designation..."
                    },
                {
                    label: "Mobile Number", type: "phone", value: userProfileDetails?.phone, required: user?.privilage?.includes("SuperAdmin") ? true : false,
                    placeholder: "Enter mobile no...",
                    disabled: user?.id === userProfileDetails?.id,
                    onChange: e => handleInputChange(e, "phone"),
                    error: (() => {
                        const phone = userProfileDetails?.phone;
                        if (!phone || phone.trim() === "" || phone === "+") {
                            return null;
                        }
                        if (!phone.startsWith("+91")) {
                            return null;
                        }
                        const hasTyped = phone.length > 3;
                        if (!hasTyped) {
                            return null;
                        }
                        if (isPhoneFormatInvalid(phone)) {
                            return "Mobile number should start with 6-9";
                        }
                        return !isValidPhoneNumber(phone) ? "Please enter valid number" : null;
                    })()
                },
                {
                    label: "Email ID", type: "text", value: userProfileDetails?.email || '', required: (user?.privilage?.includes("SuperAdmin") && window.location.pathname === "/user-profile") ? true : false,
                    disabled: user?.id === userProfileDetails?.id,
                    onChange: e => handleInputChange(e.target.value, "email"),
                    placeholder: "Enter email id...",
                    error: validateEmail(userProfileDetails?.email) ? "Enter valid email id" : null
                },
                // {label: "Access ID", type: "text", 
                //     value: userProfileDetails?.rfid, placeholder: "Enter rfid/bionmetric number...", 
                //     required:false, disabled:false,
                //     onChange:e =>handleInputChange(e.target.value, "rfid"),
                // },
                {
                    label: "Gender", type: "select", value: userProfileDetails?.basicprofile?.gender === "" || userProfileDetails?.basicprofile?.gender === "NA" || !userProfileDetails?.basicprofile?.gender ? undefined : userProfileDetails?.basicprofile?.gender, required: false, disabled: false,
                    options: ["Male", "Female", "Others"],
                    placeholder: "Select gender...",
                    onChange: e => handleInputChange(e, "basicprofile", "gender"),
                },
                {
                    label: "Blood group", type: "select", value: userProfileDetails?.basicprofile?.bloodGroup === "" || userProfileDetails?.basicprofile?.bloodGroup === "NA" ? undefined : userProfileDetails?.basicprofile?.bloodGroup, required: false, disabled: false,
                    onChange: e => handleInputChange(e, "basicprofile", "bloodGroup"),
                    options: ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"],
                    placeholder: "Select blood group...",
                },
                {
                    label: "Date of birth", type: "date", value: userProfileDetails?.basicprofile?.dob, required: false, disabled: false,
                    onChange: e => handleInputChange(e, "basicprofile", "dob"),
                    placeholder: "DD-MM-YYYY",
                    disabledDate: disabledDate
                },
                {
                    label: "User type", type: "text",
                    value: Array.isArray(userProfileDetails?.role)
                        ? userProfileDetails?.role.map(r => r === 'Operation' ? 'Operations' : r).join(', ')
                        : (userProfileDetails?.role === 'Operation' ? 'Operations' : userProfileDetails?.role),
                    required: true, disabled: true,
                    placeholder: "Select role...",
                },
                userRowDetails?.role == 'Student' || isStudent ? null : (user?.id === userProfileDetails?.id ? (userProfileDetails?.privilage?.length ? { label: "Privilege(s)", type: "bullet", value: userProfileDetails?.privilage, disabled: true, onChange: {} } : undefined) : { label: 'Privilege(s)', type: 'Checkbox', value: privilages, /* required: true, */ disabled: false, onChange: (e) => onCheckChange(e) }),
            ]
        },
        {
            heading: "Current address",
            fields: [
                {
                    label: "House no./locality/area", type: "text", value: userProfileDetails?.basicprofile?.currentAddress.h_no || "", required: false, disabled: false,
                    onChange: e => {
                        handleInputChange(e.target.value, "basicprofile", "currentAddress", 'h_no')
                        if (userProfileDetails?.basicprofile?.permanentAddress?.sameAsCa || sameAsCa) {
                            handleInputChange(e.target.value, "basicprofile", "permanentAddress", 'h_no')
                        }
                    },
                    placeholder: "Enter house no./locality/area..."
                },
                {
                    label: "Pincode", type: "text", value: userProfileDetails?.basicprofile?.currentAddress.pincode || "", required: false, disabled: false,
                    onChange: e => {
                        const val = e.target.value;
                        handleInputChange(val, "basicprofile", "currentAddress", 'pincode')
                        if (userProfileDetails?.basicprofile?.permanentAddress?.sameAsCa || sameAsCa) {
                            handleInputChange(val, "basicprofile", "permanentAddress", 'pincode')
                        }
                        if (val === "" || val.length === 6) {
                            validateData(val, "basicprofile", "currentAddress", "pincode");
                        }
                    },
                    placeholder: "Enter pincode...",
                    onFocusChange: e => validateData(e.target.value, "basicprofile", "currentAddress", "pincode"),
                    error: (() => {
                        const pin = userProfileDetails?.basicprofile?.currentAddress?.pincode;
                        if (pin && pin.length >= 1 && pin.length < 6) {
                            return "Enter valid pincode";
                        }
                        return userProfileDetails?.basicprofile?.currentAddress?.pincodeValid ? "Enter valid pincode" : "";
                    })()
                },
                {
                    label: "State", type: "text", value: userProfileDetails?.basicprofile?.currentAddress.state || "", required: false, disabled: false,
                    onChange: e => {
                        handleInputChange(e.target.value, "basicprofile", "currentAddress", 'state')
                        if (userProfileDetails?.basicprofile?.permanentAddress?.sameAsCa || sameAsCa) {
                            handleInputChange(e.target.value, "basicprofile", "permanentAddress", 'state')
                        }
                    },
                    placeholder: "Enter state..."
                },
                {
                    label: "District", type: "text", value: userProfileDetails?.basicprofile?.currentAddress.city || "", required: false, disabled: false,
                    onChange: e => {
                        handleInputChange(e.target.value, "basicprofile", "currentAddress", 'city')
                        if (userProfileDetails?.basicprofile?.permanentAddress?.sameAsCa || sameAsCa) {
                            handleInputChange(e.target.value, "basicprofile", "permanentAddress", 'city')
                        }
                    },
                    placeholder: "Enter district/city..."
                },
                {
                    label: "Country", type: "text", value: userProfileDetails?.basicprofile?.currentAddress.country || "", required: false, disabled: false,
                    onChange: e => {
                        handleInputChange(e.target.value, "basicprofile", "currentAddress", 'country')
                        if (userProfileDetails?.basicprofile?.permanentAddress?.sameAsCa || sameAsCa) {
                            handleInputChange(e.target.value, "basicprofile", "permanentAddress", 'country')
                        }
                    },
                    placeholder: "Enter country..."
                },
            ]
        },
        {
            heading: "Permanent address",
            checkbox: {

                text: "Same as current address",
                value: dummySameAsCa ? false : sameAsCa,
                action: (e) => { handleAddrDuplicate(e.target.checked, userProfileDetails); if (dummySameAsCa) setDummySameAsCa(false) }
            },
            fields: [
                {
                    label: "House no./locality/area", type: "text", value: userProfileDetails?.basicprofile?.permanentAddress.h_no || "", required: false, disabled: false,
                    onChange: (e) => {
                        handleInputChange(e.target.value, "basicprofile", "permanentAddress", 'h_no');
                        if (sameAsCa) setDummySameAsCa(true)
                    },
                    placeholder: "Enter house no./locality/area..."
                },
                {
                    label: "Pincode", type: "text", value: userProfileDetails?.basicprofile?.permanentAddress.pincode || "", required: false, disabled: false,
                    onChange: (e) => {
                        const val = e.target.value;
                        handleInputChange(val, "basicprofile", "permanentAddress", 'pincode');
                        if (sameAsCa) setDummySameAsCa(true);
                        if (val === "" || val.length === 6) {
                            validateData(val, "basicprofile", "permanentAddress", "pincode");
                        }
                    },
                    placeholder: "Enter pincode...",
                    onFocusChange: e => validateData(e.target.value, "basicprofile", "permanentAddress", "pincode"),
                    error: (() => {
                        const pin = userProfileDetails?.basicprofile?.permanentAddress?.pincode;
                        if (pin && pin.length >= 1 && pin.length < 6) {
                            return "Enter valid pincode";
                        }
                        return userProfileDetails?.basicprofile?.permanentAddress?.pincodeValid ? "Enter valid pincode" : "";
                    })()
                },
                {
                    label: "State", type: "text", value: userProfileDetails?.basicprofile?.permanentAddress.state || "", required: false, disabled: false,
                    onChange: (e) => { handleInputChange(e.target.value, "basicprofile", "permanentAddress", 'state'); if (sameAsCa) setDummySameAsCa(true) },
                    placeholder: "Enter state..."
                },
                {
                    label: "District", type: "text", value: userProfileDetails?.basicprofile?.permanentAddress.city || "", required: false, disabled: false,
                    onChange: (e) => { handleInputChange(e.target.value, "basicprofile", "permanentAddress", 'city'); if (sameAsCa) setDummySameAsCa(true) },
                    placeholder: "Enter district/city..."
                },
                {
                    label: "Country", type: "text", value: userProfileDetails?.basicprofile?.permanentAddress.country || "", required: false, disabled: false,
                    onChange: (e) => { handleInputChange(e.target.value, "basicprofile", "permanentAddress", 'country'); if (sameAsCa) setDummySameAsCa(true) },
                    placeholder: "Enter country..."
                },
            ]
        },
        {
            heading: "Emergency contact",
            fields: [
                {
                    label: "Name", type: "text", value: userProfileDetails?.basicprofile?.emergencyContactName === 'NA' || userProfileDetails?.basicprofile?.emergencyContactName === null ? '' : userProfileDetails?.basicprofile?.emergencyContactName, required: false, disabled: false,
                    onChange: e => handleInputChange(e.target.value, "basicprofile", "emergencyContactName"),
                    placeholder: "Enter name..."
                },
                {
                    label: "Mobile Number", type: "phone", value: userProfileDetails?.basicprofile?.emergencyPhone, required: false, disabled: false,
                    onChange: e => handleInputChange(e, "basicprofile", "emergencyPhone"),
                    placeholder: "Enter mobile no...",
                    error: (() => {
                        const emergency = userProfileDetails?.basicprofile?.emergencyPhone;
                        if (!emergency || emergency === "NA" || emergency.trim() === "" || emergency === "+") {
                            return null;
                        }
                        const hasTyped = emergency.startsWith("+91") ? emergency.length > 3 : true;
                        if (emergency.startsWith("+91")) {
                            if (hasTyped && isPhoneFormatInvalid(emergency)) {
                                return "Mobile number should start with 6-9";
                            }
                            if (hasTyped && !isValidPhoneNumber(emergency)) {
                                return "Please enter valid number";
                            }
                        }
                        const primary = userProfileDetails?.phone;
                        if (!primary) return phoneExistsError || null;
                        const clean = (num) => String(num).replace(/[^0-9]/g, '');
                        const p = clean(primary);
                        const e = clean(emergency);
                        if (!p || !e) return phoneExistsError || null;
                        return p.slice(-10) === e.slice(-10) ? "Emergency contact number cannot be same as primary mobile number" : (phoneExistsError || null);
                    })()
                },
                {
                    label: "Relationship", type: "select", value: ((userProfileDetails?.basicprofile?.emergencyContactName == 'NA' || userProfileDetails?.basicprofile?.emergencyContactName == '') || (userProfileDetails?.basicprofile?.emergencyPhone == 'NA' || userProfileDetails?.basicprofile?.emergencyPhone == undefined || userProfileDetails?.basicprofile?.emergencyPhone == '' || userProfileDetails?.basicprofile?.emergencyPhone == null) ? null : userProfileDetails?.basicprofile?.relationship), required: false, disabled: ((userProfileDetails?.basicprofile?.emergencyContactName == 'NA' || userProfileDetails?.basicprofile?.emergencyContactName == '') || (userProfileDetails?.basicprofile?.emergencyPhone == 'NA' || userProfileDetails?.basicprofile?.emergencyPhone == undefined || userProfileDetails?.basicprofile?.emergencyPhone == '' || userProfileDetails?.basicprofile?.emergencyPhone == null)),
                    onChange: (value) => handleInputChange(value, "basicprofile", "relationship"),
                    options: ["Father", "Mother", "Uncle", "Aunt", "Brother", "Sister", "Others"],
                    placeholder: "Select relation..."
                },

            ]
        },

    ]

}



export const otherUserProfileDetails = (userProfileDetails, handleInputChange, user, validateData, handleAddrDuplicate, userRowDetails, onCheckChange, privilages, phoneExistsError) => {

    const isStudent = userProfileDetails?.role?.includes('Student');

    function disabledDate(current) {
        // Can not select days before today and today
        return !(
            current &&
            current < moment().subtract(user?.role?.includes('Student') ? 6 : 14, "years")
        );
    }

    let sameAsCa = false;
    const permanentAddress = userProfileDetails?.basicprofile?.permanentAddress || userProfileDetails?.user?.basicprofile?.permanentAddress;

    if (typeof permanentAddress === "string" && permanentAddress.trim() !== "") {
        try {
            const parsedAddress = JSON.parse(permanentAddress);
            sameAsCa = parsedAddress?.sameAsCa ?? false;
        } catch (error) {
            console.error("Error parsing permanentAddress:", error);
            sameAsCa = false;
        }
    } else if (typeof permanentAddress === "object") {
        sameAsCa = permanentAddress?.sameAsCa ?? false;
    }

    // mirrors the backend gate: anyone may enrol themselves, enrolling someone else needs admin
    const canRegisterBiometric = user?.id === userProfileDetails?.id
        || (Array.isArray(user?.privilage) ? user.privilage : [])
            .some(p => ["superadmin", "admin"].includes(String(p).toLowerCase()));

    return [
        {
            heading: "Basic information",
            fields: [
                {
                    label: "Name", type: "text", value:
                        userProfileDetails?.name, required: true, disabled: false,
                    onChange: e => handleInputChange(e.target.value, "name"),
                    placeholder: "Enter name..."
                },
                {
                    label: isStudent ? "Student Code" : "Employee Code",
                    type: "text",
                    value: userProfileDetails?.attendanceEmpCode || "",
                    required: !!userProfileDetails?.registerBiometric,
                    disabled: !(
                        // SuperAdmin can edit anyone (including self)
                        user?.privilage?.includes("SuperAdmin") ||

                        // Admin can edit anyone except a Super Admin - themselves and other Admins included
                        (
                            user?.privilage?.includes("Admin") &&
                            !userProfileDetails?.privilage?.includes("SuperAdmin")
                        ) ||

                        // LeaveManager can edit users who are NOT SuperAdmin or Admin
                        (
                            user?.privilage?.includes("LeaveManager") &&
                            !userProfileDetails?.privilage?.includes("SuperAdmin") &&
                            !userProfileDetails?.privilage?.includes("Admin")
                        )
                    ),

                    onChange: e => handleInputChange(e.target.value, "attendanceEmpCode"),
                    placeholder: isStudent ? "Enter Student Code..." : "Enter Employee Code...",
                    error: attendanceCodeError(userProfileDetails?.attendanceEmpCode),
                    key: `emp-code-${userProfileDetails?.attendanceEmpCode || "empty"}`,
                    checkboxAbove: canRegisterBiometric ? {
                        label: "Register on biometric device",
                        checked: !!userProfileDetails?.registerBiometric,
                        onChange: e => handleInputChange(e.target.checked, "registerBiometric"),
                    } : null
                },
                {
                    label: "User type", type: "text",
                    value: Array.isArray(userProfileDetails?.role)
                        ? userProfileDetails?.role.map(r => r === 'Operation' ? 'Operations' : r).join(', ')
                        : (userProfileDetails?.role === 'Operation' ? 'Operations' : userProfileDetails?.role),
                    required: true, disabled: true,
                    placeholder: "Select role...",
                },
                {
                    label: "Mobile Number", type: "phone", value: userProfileDetails?.phone, required: user?.privilage?.includes("SuperAdmin") ? true : false,
                    placeholder: "Enter mobile no...",
                    disabled: !(user?.id === userProfileDetails?.id) && !user?.privilage?.includes("SuperAdmin") && !(user?.privilage?.includes("Admin") && !(userProfileDetails?.privilage?.includes("SuperAdmin") || userProfileDetails?.privilage?.includes("Admin"))),
                    onChange: e => handleInputChange(e, "phone"),
                    error: (() => {
                        const phone = userProfileDetails?.phone;
                        if (!phone || phone.trim() === "" || phone === "+") {
                            return null;
                        }
                        if (!phone.startsWith("+91")) {
                            return null;
                        }
                        const hasTyped = phone.length > 3;
                        if (!hasTyped) {
                            return null;
                        }
                        if (isPhoneFormatInvalid(phone)) {
                            return "Mobile number should start with 6-9";
                        }
                        return !isValidPhoneNumber(phone) ? "Please enter valid number" : null;
                    })()
                },
                {
                    label: "Email ID", type: "text", value: userProfileDetails?.email || '', /* required: user?.privilage?.includes("SuperAdmin") ? true : false, */
                    onChange: e => handleInputChange(e.target.value, "email"),
                    placeholder: "Enter email id...",
                    disabled: !(user?.privilage?.includes("Admin") || user?.privilage?.includes("SuperAdmin") || user?.id === userProfileDetails?.id),
                    error: validateEmail(userProfileDetails?.email) ? "Enter valid email id" : null
                },
                {
                    label: "Blood group", type: "select", value: userProfileDetails?.basicprofile?.bloodGroup === "" || userProfileDetails?.basicprofile?.bloodGroup === "NA" ? null : userProfileDetails?.basicprofile?.bloodGroup, required: false, disabled: false,
                    onChange: e => handleInputChange(e, "basicprofile", "bloodGroup"),
                    options: ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"],
                    placeholder: "Select blood group...",
                    space: 0.5
                },
                {
                    label: "Gender", type: "select", value: userProfileDetails?.basicprofile?.gender === "" || userProfileDetails?.basicprofile?.gender === "NA" || !userProfileDetails?.basicprofile?.gender ? undefined : userProfileDetails?.basicprofile?.gender, required: false, disabled: false,
                    options: ["Male", "Female", "Others"],
                    placeholder: "Select gender...",
                    onChange: e => handleInputChange(e, "basicprofile", "gender"),
                    space: 0.5
                },

                {
                    label: "Date of birth", type: "date", value: userProfileDetails?.basicprofile?.dob, required: false, disabled: false,
                    onChange: e => handleInputChange(e, "basicprofile", "dob"),
                    placeholder: "DD-MM-YYYY",
                    disabledDate: disabledDate
                },
                userRowDetails?.role == 'Student' || isStudent ? null : (user?.id === userProfileDetails?.id ? (userProfileDetails?.privilage?.length ? { label: "Privilege(s)", type: "bullet", value: userProfileDetails?.privilage, disabled: true, onChange: {} } : undefined) : { label: 'Privilege(s)', type: 'Checkbox', value: privilages, /* required: true, */ disabled: false, onChange: (e) => onCheckChange(e) }),
            ]
        },
        {
            heading: "Current address",
            fields: [
                {
                    label: "House no./locality/area", type: "text", value: userProfileDetails?.basicprofile?.currentAddress.h_no || '', required: false, disabled: false,
                    onChange: e => {
                        handleInputChange(e.target.value, "basicprofile", "currentAddress", 'h_no')
                        if (userProfileDetails?.basicprofile?.permanentAddress?.sameAsCa) {
                            handleInputChange(e.target.value, "basicprofile", "permanentAddress", 'h_no')
                        }
                    },
                    placeholder: "Enter house no./locality/area..."
                },
                {
                    label: "Pincode", type: "text", value: userProfileDetails?.basicprofile?.currentAddress.pincode || '', required: false, disabled: false,
                    onChange: e => {
                        const val = e.target.value;
                        handleInputChange(val, "basicprofile", "currentAddress", 'pincode')
                        if (userProfileDetails?.basicprofile?.permanentAddress?.sameAsCa) {
                            handleInputChange(val, "basicprofile", "permanentAddress", 'pincode')
                        }
                        if (val === "" || val.length === 6) {
                            validateData(val, "basicprofile", "currentAddress", "pincode");
                        }
                    },
                    placeholder: "Enter pincode...",
                    onFocusChange: e => validateData(e.target.value, "basicprofile", "currentAddress", "pincode"),
                    error: (() => {
                        const pin = userProfileDetails?.basicprofile?.currentAddress?.pincode;
                        if (pin && pin.length >= 1 && pin.length < 6) {
                            return "Enter valid pincode";
                        }
                        return userProfileDetails?.basicprofile?.currentAddress?.pincodeValid ? "Enter valid pincode" : "";
                    })()
                },
                {
                    label: "State", type: "text", value: userProfileDetails?.basicprofile?.currentAddress.state || '', required: false, disabled: false,
                    onChange: e => {
                        handleInputChange(e.target.value, "basicprofile", "currentAddress", 'state')
                        if (userProfileDetails?.basicprofile?.permanentAddress?.sameAsCa) {
                            handleInputChange(e.target.value, "basicprofile", "permanentAddress", 'state')
                        }
                    },
                    placeholder: "Enter state..."
                },
                {
                    label: "District", type: "text", value: userProfileDetails?.basicprofile?.currentAddress.city || '', required: false, disabled: false,
                    onChange: e => {
                        handleInputChange(e.target.value, "basicprofile", "currentAddress", 'city')
                        if (userProfileDetails?.basicprofile?.permanentAddress?.sameAsCa) {
                            handleInputChange(e.target.value, "basicprofile", "permanentAddress", 'city')
                        }
                    },
                    placeholder: "Enter district/city..."
                },
                {
                    label: "Country", type: "text", value: userProfileDetails?.basicprofile?.currentAddress.country || '', required: false, disabled: false,
                    onChange: e => {
                        handleInputChange(e.target.value, "basicprofile", "currentAddress", 'country')
                        if (userProfileDetails?.basicprofile?.permanentAddress?.sameAsCa) {
                            handleInputChange(e.target.value, "basicprofile", "permanentAddress", 'country')
                        }
                    },
                    placeholder: "Enter country..."
                },
            ]
        },
        {
            heading: "Permanent address",
            checkbox: {
                text: "Same as current address",
                value: sameAsCa,
                action: (e) => handleAddrDuplicate(e.target.checked, userProfileDetails)
            },
            fields: [
                {
                    label: "House no./locality/area", type: "text", value: userProfileDetails?.basicprofile?.permanentAddress.h_no || '', required: false, disabled: false,
                    onChange: e => handleInputChange(e.target.value, "basicprofile", "permanentAddress", 'h_no'),
                    placeholder: "Enter house no./locality/area..."
                },
                {
                    label: "Pincode", type: "text", value: userProfileDetails?.basicprofile?.permanentAddress.pincode || '', required: false, disabled: false,
                    onChange: e => {
                        const val = e.target.value;
                        handleInputChange(val, "basicprofile", "permanentAddress", 'pincode');
                        if (val === "" || val.length === 6) {
                            validateData(val, "basicprofile", "permanentAddress", "pincode");
                        }
                    },
                    placeholder: "Enter pincode...",
                    onFocusChange: e => validateData(e.target.value, "basicprofile", "permanentAddress", "pincode"),
                    error: (() => {
                        const pin = userProfileDetails?.basicprofile?.permanentAddress?.pincode;
                        if (pin && pin.length >= 1 && pin.length < 6) {
                            return "Enter valid pincode";
                        }
                        return userProfileDetails?.basicprofile?.permanentAddress?.pincodeValid ? "Enter valid pincode" : "";
                    })()
                },
                {
                    label: "State", type: "text", value: userProfileDetails?.basicprofile?.permanentAddress.state || '', required: false, disabled: false,
                    onChange: e => handleInputChange(e.target.value, "basicprofile", "permanentAddress", 'state'),
                    placeholder: "Enter state..."
                },
                {
                    label: "District", type: "text", value: userProfileDetails?.basicprofile?.permanentAddress.city || '', required: false, disabled: false,
                    onChange: e => handleInputChange(e.target.value, "basicprofile", "permanentAddress", 'city'),
                    placeholder: "Enter district/city..."
                },
                {
                    label: "Country", type: "text", value: userProfileDetails?.basicprofile?.permanentAddress.country || '', required: false, disabled: false,
                    onChange: e => handleInputChange(e.target.value, "basicprofile", "permanentAddress", 'country'),
                    placeholder: "Enter country..."
                },
            ]
        },
        {
            heading: "Emergency contact",
            fields: [
                {
                    label: "Name", type: "text", value: userProfileDetails?.basicprofile?.emergencyContactName === 'NA' || userProfileDetails?.basicprofile?.emergencyContactName === null ? '' : userProfileDetails?.basicprofile?.emergencyContactName, required: false, disabled: false,
                    onChange: e => handleInputChange(e.target.value, "basicprofile", "emergencyContactName"),
                    placeholder: "Enter name..."
                },
                {
                    label: "Mobile Number", type: "phone", value: userProfileDetails?.basicprofile?.emergencyPhone, required: false, disabled: false,
                    onChange: e => handleInputChange(e, "basicprofile", "emergencyPhone"),
                    placeholder: "Enter mobile no...",
                    error: (() => {
                        const emergency = userProfileDetails?.basicprofile?.emergencyPhone;
                        if (!emergency || emergency === "NA" || emergency.trim() === "" || emergency === "+") {
                            return null;
                        }
                        const hasTyped = emergency.startsWith("+91") ? emergency.length > 3 : true;
                        if (emergency.startsWith("+91")) {
                            if (hasTyped && isPhoneFormatInvalid(emergency)) {
                                return "Mobile number should start with 6-9";
                            }
                            if (hasTyped && !isValidPhoneNumber(emergency)) {
                                return "Please enter valid number";
                            }
                        }
                        const primary = userProfileDetails?.phone;
                        if (!primary) return phoneExistsError || null;
                        const clean = (num) => String(num).replace(/[^0-9]/g, '');
                        const p = clean(primary);
                        const e = clean(emergency);
                        if (!p || !e) return phoneExistsError || null;
                        return p.slice(-10) === e.slice(-10) ? "Emergency contact number cannot be same as primary mobile number" : (phoneExistsError || null);
                    })()
                },
                {
                    label: "Relationship", type: "select", value: userProfileDetails?.basicprofile?.relationship, required: false, disabled: false,
                    onChange: (value) => handleInputChange(value, "basicprofile", "relationship"),
                    options: ["Father", "Mother", "Uncle", "Aunt", "Brother", "Sister", "Others"],
                    placeholder: "Select relation..."
                },

            ]
        },

    ]
}